// ColorTrail.ts

import { Trail } from "./Trail";
import { Coordinates } from "./Types";
import { generateHexColor } from "../Utilities/Colors";

// export interface ColorCoordinates extends Coordinates {
//   color: string;
// }

/**
 * A class to manage a fixed-size queue of coordinates with associated colors.
 * Each point is drawn with its assigned color.
 */
export class ColorTrail extends Trail {
  protected trailColors: string[] = [];
  private colorIndex: number = 0;
  private colorIndexIncrement: number = 3.5;

  /**
   * Adds a new coordinate to the trail with an associated color.
   * @param coord - The coordinate to add.
   */
  add(coord: Coordinates, now: number): Coordinates | undefined {
    const removed = super.add(coord, now);
    const color = generateHexColor(this.colorIndex);
    this.colorIndex += this.colorIndexIncrement;
    this.trailColors.push(color);
    if (removed) {
      this.trailColors.shift();
    }
    return removed;
  }

  /**
   * Draws the trail on the canvas.
   * Each line segment is drawn with the color of its starting point.
   * @param ctx - The canvas rendering context.
   * @param scale - The scale factor for the coordinates.
   * @param offset - The offset to apply to each coordinate.
   */
  draw(
    ctx: CanvasRenderingContext2D,
    scale: number,
    offset: Coordinates
  ): void {
    ctx.lineWidth = 2;
    for (let i = 1; i < this.trail.length; i++) {
      const start = this.trail[i - 1];
      const end = this.trail[i];
      ctx.strokeStyle = this.trailColors[i - 1];
      ctx.beginPath();
      ctx.moveTo(offset.x + scale * start.x, offset.y + scale * start.y);
      ctx.lineTo(offset.x + scale * end.x, offset.y + scale * end.y);
      ctx.stroke();
    }
  }
}
